import React, { Component } from 'react';
import './styles/css/progress-bar.css';

class ProgressBar extends Component {
    constructor() {
        super();
        this.state = {
        }
    }

    render() {

        console.log(this.props.progressData)
        
        return (
            <div className="progress-segment">
                <div className={this.props.progressData.basicInfo}></div>
                <div className={this.props.progressData.basicInfoCompany}></div>
                <div className={this.props.progressData.ai1}></div>
                <div className={this.props.progressData.ai2}></div>
                <div className={this.props.progressData.ai3}></div>
                <div className={this.props.progressData.ai4}></div>
                {/* <div className={this.props.progressData.poa}></div>
                <div className={this.props.progressData.payment}></div> */}
                <div className={this.props.progressData.addTeam}></div>
            </div>    
        )
    }
}

export default ProgressBar;